<template>
  <div class="layout-system-name-dialog">
    <div class="kye-dialog-body">
      <div class="system-name-input">
        <kye-input v-model="systemName" maxlength="40" size="small" placeholder="请输入系统名称"></kye-input>
        <el-button type="text" @click="handleReset">重置</el-button>
      </div>
      <div class="system-name-footer">
        <kye-button round type="primary" size="small" hotkey="ctrl+s" @click="handleSubmit">
          保存(S)
        </kye-button>
        <kye-button round size="small" @click="handleClose">
          取消
        </kye-button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      systemName: ''
    }
  },
  methods: {
    /**
     * 重置系统名称
     */
    handleReset() {
      this.systemName = ''
      localStorage.GLOABL_ERP_SYSTEM_NAME = ''
      this.$bus.$emit('SET_SYSTEM_NAME')
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.$emit('close')
    },
    /**
     * 提交系统名称
     */
    handleSubmit() {
      localStorage.GLOABL_ERP_SYSTEM_NAME = this.systemName
      this.$bus.$emit('SET_SYSTEM_NAME')
      this.handleClose()
    }
  }
}

</script>
<style lang='scss' scoped>
.layout-system-name-dialog {
  .system-name-input {
    display: flex;
    /deep/ .el-button {
      margin-left: 8px;
    }
    /deep/ .el-input__inner {
      border-radius: 12px;
      background: rgba(249, 249, 254, 1);
      border: 0;
      padding: 0 12px;
    }
  }
  .system-name-footer {
    text-align: right;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/update-system-name.vue